export const Locales = [{
    id: 1,
    name: "Local 1",
    value: "1"
},{
    id: 2,
    name: "Local 2",
    value: "2"
},{
    id: 3,
    name: "Local 3",
    value: "3"
}]
